// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"42af7052","183":"dd1e75ea","298":"43550efe","394":"03ba9c84","412":"883bbe13","434":"1a84437f","503":"20fb7d9a","726":"810aa942","741":"7721b920","787":"37583538","899":"6f1eb316"}[chunkId] + ".chunk.js";
};